import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useI18n } from "../lib/i18n";

export function CookieBanner() {
  const { t } = useI18n();
  const [show, setShow] = useState(() => !localStorage.getItem("lc_cookie_consent"));
  if (!show) return null;
  const choose = (v) => { localStorage.setItem("lc_cookie_consent", v); setShow(false); };
  return (
    <div
      data-testid="cookie-banner"
      className="fixed inset-x-3 bottom-3 z-[1000] mx-auto max-w-2xl rounded-2xl border border-cardline bg-card2/95 p-4 shadow-2xl backdrop-blur-xl animate-fade-in"
    >
      <div className="flex items-start gap-3">
        <div className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-gold/15 text-gold"><Cookie size={18} /></div>
        <div className="flex-1 text-sm text-slate-300">
          {t("cookieText")}{" "}
          <Link to="/legal/cookies" className="font-semibold text-gold hover:underline" data-testid="cookie-learn-more">{t("learnMore")}</Link>
        </div>
      </div>
      <div className="mt-3 flex justify-end gap-2">
        <button onClick={() => choose("declined")} data-testid="cookie-decline" className="rounded-full border border-cardline px-4 py-2 text-xs font-semibold text-slate-300 transition-colors hover:text-white">{t("decline")}</button>
        <button onClick={() => choose("accepted")} data-testid="cookie-accept" className="rounded-full bg-gold px-4 py-2 text-xs font-bold text-ink">{t("accept")}</button>
      </div>
    </div>
  );
}
